import * as React from 'react';
import * as classnames from "classnames"
import { resetImage } from '../../common/reset-image'
import doLog from '../../common/log';

const {useState, useEffect} = React;

export default function Normal(props: { seller: any; i18n: any; productId: any; }) {

  const [companyData,setCompanyData] = useState( [] );
  

  const { seller,i18n,productId} = props;
  const { overseaBrand,
      accountIsPaidMember,
      companyName,
      homeUrl,
      companyProfileUrl,
      companyBusinessType,
      companyRegisterCountry,
      tradeIsView,
      tradeHalfYear,
      companyJoinYears,
      factorySize,
      responseTimeText,
      companyAbilityTags,
      qcStaffNum,
      accountIsGoldPlusSupplier } = seller;

  const fetchData = async () => {
    const url = `/event/app/companyCardIntegrated/getSupplierData.htm?detailId=${productId}`;
    const resultData = await fetch( url ).then( res => res.json() );
    const { isSuccess,result } = resultData;
    if ( isSuccess && result ) {
        const { supplierOnTimeDeliveryRate } = result;
        const dataSource = [];
        // 回复时长
        if ( responseTimeText ) {
            dataSource.push( {
                value: responseTimeText,
                text: i18n['widget.supplierCard.resTimeTitle'],
            } );
        }
        // 按时发货率
        if ( supplierOnTimeDeliveryRate ) {
            dataSource.push( {
                value: supplierOnTimeDeliveryRate,
                text: i18n['companyCardIntegrated.ontimeShipment'],
            } );
        }
        // 成交价格
        if (
            tradeIsView &&
            tradeHalfYear &&
            tradeHalfYear.ordAmt &&
            tradeHalfYear.ordCnt6m &&
            tradeHalfYear.ordCnt6m > 0
        ) {
            dataSource.push( {
                value: tradeHalfYear.ordAmt,
                text: `${tradeHalfYear.ordCnt6m} ${i18n['widget.supplierCard.transactions']}`,
            } );
        }
        // 工厂面积
        if ( factorySize ) {
            dataSource.push( {
                value: factorySize,
                text: i18n['Verified.tag.detail.mj'],
            } );
        }
        // 商家证书图片列表
        if (
            seller.companyCertLogoList &&
            seller.companyCertLogoList.length > 0
        ) {
            dataSource.push( {
                value: seller.companyCertLogoList.join( ',' ),
                images: seller.companyCertLogoList,
                text: i18n['Verified.tag.detail.company.cert'],
            } );
        }
        // 质检人员数量
        if ( qcStaffNum ) {
            dataSource.push( {
                value: qcStaffNum,
                text: i18n['Verified.tag.detail.qc.staff.num'],
            } );
        }
        // 专利数量
        if ( seller.patentNum ) {
            dataSource.push( {
                value: seller.patentNum,
                text: i18n['Verified.tag.detail.patent'],
            } );
        }
        // 研发人员
        if ( seller.rndStaffNum ) {
            dataSource.push( {
                value: seller.rndStaffNum,
                text: i18n['Verified.tag.detail.rdstaff'],
            } );
        }
        // 雇员数量
        if ( seller.employeesCount ) {
            dataSource.push( {
                value: seller.employeesCount,
                text: i18n['Verified.tag.detail.staff'],
            } );
        }

        setCompanyData( dataSource as any );
    }
};

  useEffect( () => {
    fetchData();
  },[] );

  // 付费用户
  const isPS = accountIsPaidMember && !accountIsGoldPlusSupplier;
  // 金标用户
  const isGS = accountIsPaidMember && accountIsGoldPlusSupplier;
  const cls = classnames( {
      "company-card": true,
      "is-ps": isPS && !overseaBrand,
      "is-gs": isGS
  } );

  const renderItem = ( item: {
      text: string;
      value: string;
      images: any;
  },index: number ) => {
      return <div className="company-info" key={index}>
          <div className="info-title">{item.text}</div>
          {item.images ?
              <div className="info-intro">{item.images.map( ( i: string ) => <img key={i} src={i} /> )}</div> :
              <div className="info-intro">{item.value}</div>}
      </div>;
  };


  return (
    <div className={cls}>
            <div className="company-head">
                <div className="company-tag">
                    <img src={resetImage( "https://img.alicdn.com/imgextra/i1/O1CN01AOhmtZ1HQ08UWY7sf_!!6000000000751-2-tps-266-54.png" )} />
                </div>
                <div className="company-item">
                    <a href={homeUrl} data-aui="company-name" data-domdot="id:3317" onClick={() => doLog('/sc.details.companyCard', 'item=url')}>{companyName}</a>
                </div>
                <div className="company-item">
                    {overseaBrand && (
                        <img
                            src={resetImage( "https://img.alicdn.com/imgextra/i4/O1CN01350gqJ1cjKkuKUxqc_!!6000000003636-2-tps-76-26.png" )}
                            height="14px"
                        />
                    )}
                    {companyBusinessType}
                </div>
                <div className="company-item">
                    {companyRegisterCountry.toLowerCase() !== "tw" && <div className="company-country">
                        <img src={`https://u.alicdn.com/mobile/g/common/flags/1.0.0/assets/${companyRegisterCountry.toLowerCase()}.png`} />
                        <span>{companyRegisterCountry}</span>
                    </div>}
                    <div className="company-year">
                        {companyJoinYears}
                    </div>
                </div>
            </div>
            <div className="company-body">
                {companyData.slice( 0,6 ).map( ( item,index ) => renderItem( item,index ) )}
            </div>
            {companyAbilityTags &&
                companyAbilityTags.map( ( item: { tagNameValue: string | number | boolean | {} | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactNodeArray | React.ReactPortal; },index: React.Key ) => (
                    <div className="ability" key={index}>
                        <img
                            src={resetImage( 'https://img.alicdn.com/imgextra/i3/O1CN015NySK71aBmY1PTG9K_!!6000000003292-2-tps-28-28.png' )}
                        />
                        {item.tagNameValue}
                    </div>
                ) )}
        </div>
  )
}
